import { call, put, takeEvery } from "redux-saga/effects";
import {
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../../helpers/utils";
import {
  hideCampaignAdvertisingAccountsListLoader,
  setCampaignAdvertisingAccountProfile,
  setCampaignAdvertisingAccountsList,
  setCampaignCustomerData,
  showCampaignAdvertisingAccountsListLoader,
} from "./actions";
import {
  deleteCampaignAdvertisingAccount,
  getCampaignAdvertisingAccount,
  getCampaignAdvertisingAccountCustomerData,
  getCampaignAdvertisingAccountProfile,
  getCampaignCashbacks,
  postCampaignAdvertisingAccount,
  putCampaignAdvertisingAccountProfile,
  postWarehouseLoadPlatformCabinets,
} from "../../../helpers/jwt_helper";
import {
  ADD_CAMPAIGN_ADVERTISING_ACCOUNTS,
  DELETE_CAMPAIGN_ADVERTISING_ACCOUNTS,
  GET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE,
  GET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST,
  UPDATE_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE,
  GET_CAMPAIGN_CUSTOMER_DATA,
  WAREHOUSE_PLATFORM_TRIGGER,
} from "./actionTypes";
import { setCampaignCashbacksList } from "../cashbacks/actions";

// Chat Redux States
function* onGetCampaignAdvertisingAccountList({ payload: data }) {
  try {
    yield put(showCampaignAdvertisingAccountsListLoader());
    let response = yield call(getCampaignAdvertisingAccount, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });

    let cashbacks = yield call(getCampaignCashbacks, {
      size: 0,
    });
    // debugger
    if (response.results) {
      response.results.forEach(item => {
        item.cashbackNames = item.cashbacks
          .map(cashback => {
            return cashbacks.find(item2 => item2.id === cashback).name;
          })
          .join(", ");
      });

      response = {
        ...data,
        ...response,
      };
    } else {
      response.forEach(item => {
        item.cashbackNames = item.cashbacks
          .map(cashback => {
            return cashbacks.find(item2 => item2.id === cashback).name;
          })
          .join(", ");
      });
    }

    yield put(setCampaignAdvertisingAccountsList(response));
    yield put(setCampaignCashbacksList(cashbacks));
    yield put(hideCampaignAdvertisingAccountsListLoader());
  } catch (error) {
    yield put(hideCampaignAdvertisingAccountsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCampaignAdvertisingAccount({ payload: { cabinet, data } }) {
  try {
    yield put(showCampaignAdvertisingAccountsListLoader());
    yield call(postCampaignAdvertisingAccount, {
      name: cabinet.name,
      ad_platform: cabinet.ad_platform,
      platform_cabinet_id: cabinet.platform_cabinet_id,
      cashbacks: cabinet.cashbacks,
      custom_name: cabinet?.custom_name || null
    });
    yield call(onGetCampaignAdvertisingAccountList, { payload: data });
    yield put(hideCampaignAdvertisingAccountsListLoader());
    showSuccessMessage("Campaign advertising account has been added");
  } catch (error) {
    yield put(hideCampaignAdvertisingAccountsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteAdvertisingAccount({ payload: { id, data } }) {
  try {
    yield put(showCampaignAdvertisingAccountsListLoader());
    yield call(deleteCampaignAdvertisingAccount, id);
    yield call(onGetCampaignAdvertisingAccountList, { payload: data });
    yield put(hideCampaignAdvertisingAccountsListLoader());
    showSuccessMessage("Campaign advertising account has been deleted");
  } catch (error) {
    yield put(hideCampaignAdvertisingAccountsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignAdvertisingAccountProfile({ payload: id }) {
  try {
    yield put(showCampaignAdvertisingAccountsListLoader());
    let response = yield call(getCampaignAdvertisingAccountProfile, id);
    let cashbacks = yield call(getCampaignCashbacks, {
      size: 0,
    });
    yield put(setCampaignCashbacksList(cashbacks));
    yield put(setCampaignAdvertisingAccountProfile(response));
    yield put(hideCampaignAdvertisingAccountsListLoader());
  } catch (error) {
    yield put(hideCampaignAdvertisingAccountsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onUpdateCampaignAdvertisingAccountProfile({
  payload: { id, cabinet, data },
}) {
  try {
    yield put(showCampaignAdvertisingAccountsListLoader());
    yield call(putCampaignAdvertisingAccountProfile, id, {
      name: cabinet.name,
      ad_platform: cabinet.ad_platform,
      platform_cabinet_id: cabinet.platform_cabinet_id,
      cashbacks: cabinet.cashbacks,
      custom_name: cabinet?.custom_name || null
    });
    yield call(onGetCampaignAdvertisingAccountList, { payload: data });
    yield put(hideCampaignAdvertisingAccountsListLoader());
    showSuccessMessage("Campaign advertising account has been updated");
    yield put(setCampaignAdvertisingAccountProfile(null));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignCustomerData() {
  try {
    let res = yield call(getCampaignAdvertisingAccountCustomerData);
    yield put(setCampaignCustomerData(res));
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
  }
}

function* onGetPostWarehouseTrigger({ payload: platforms }) {
  try {
    let res = yield call(postWarehouseLoadPlatformCabinets, platforms);
    showSuccessMessage(
      "The platform has been queued up, after 1 minute please reload the page to update the table data."
    );
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
  }
}

function* campaignAdvertisingAccountListSaga() {
  yield takeEvery(
    GET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST,
    onGetCampaignAdvertisingAccountList
  );
  yield takeEvery(
    DELETE_CAMPAIGN_ADVERTISING_ACCOUNTS,
    onDeleteAdvertisingAccount
  );
  yield takeEvery(
    ADD_CAMPAIGN_ADVERTISING_ACCOUNTS,
    onAddCampaignAdvertisingAccount
  );
  yield takeEvery(
    GET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE,
    onGetCampaignAdvertisingAccountProfile
  );
  yield takeEvery(
    UPDATE_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE,
    onUpdateCampaignAdvertisingAccountProfile
  );
  yield takeEvery(GET_CAMPAIGN_CUSTOMER_DATA, onGetCampaignCustomerData);
  yield takeEvery(WAREHOUSE_PLATFORM_TRIGGER, onGetPostWarehouseTrigger);
}

export default campaignAdvertisingAccountListSaga;
